<template>
  <div :class="['leftBar flex flex-col bg-transparent w-16 items-center justify-between text-costeaDarkGray', {'w-48': dashboard.topBarExtendMenu}]">
      <div class="flex flex-col text-t20 w-full">
        <button
            v-for="option in dashboard.LefBarMenus"
            :key="option.index"
            @click="selected = option.component, $router.push({name: option.component})"
            :class="[stylesButtons, {active: selected == option.component}]"
            v-show="option.component !== 'user-management'"
            >
            <i :class="option.icon"></i>
            <p v-if="dashboard.topBarExtendMenu" :class="[stylesTextButtons]">{{option.name}}</p>
        </button>
        <div v-if="this.rol_usuario !== '3'">
        <button
            v-for="option in dashboard.LefBarMenus"
            :key="option.index"
            @click="selected = option.component, $router.push({name: option.component})"
            :class="[stylesButtons, {active: selected == option.component}]"
            v-show="option.component === 'user-management'"
            >
            <i :class="option.icon"></i>
            <p v-if="dashboard.topBarExtendMenu" :class="[stylesTextButtons]">{{option.name}}</p>
        </button>
        </div>
      </div>
      <div class="leftBarSeparator flex flex-col text-t20 w-full pb-4 relative">
          <button 
            v-for="helpMenu in dashboard.LeftBarHelpMenus"
            :key="helpMenu.index"
            @click="selected = helpMenu.component, $router.push({name: helpMenu.component})"
            :class="[stylesButtons,{active: selected == helpMenu.component}]">
              <i :class="helpMenu.icon"></i>
              <p v-if="dashboard.topBarExtendMenu" :class="[stylesTextButtons]">{{helpMenu.name}}</p>
          </button>
      </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
    name: 'LeftBar',
    data: function(){
        return{
            selected: this.$route.name,
            stylesButtons: "flex items-center justify-start align-center w-full hover:bg-costeaBtn2 hover:text-costeaPrimary py-4 px-4",
            stylesTextButtons: "font-costea text-left text-t14 pl-2",
            rol_usuario: localStorage.getItem('rol_usuario')
        }
    },
    computed:{
        ...mapState(['dashboard']),
    }
    
}
</script>

<style>
.leftBar{
    z-index: 1;
    height: calc(100vh - 4rem);
}
.leftBarSeparator::after{
    content: "";
    width: 50%;
    height: 1px;
    background: #d8dee8;
    position: absolute;
    top: 0;
    left: 25%;
    
}
.active{
  color: #056cf2 !important;
  font-weight: 500;
  outline: none !important;
}

</style>
